export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST"
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL"


export const USER_SIGNUP_REQUEST = "USER_SIGNUP_REQUEST"
export const USER_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS"
export const USER_SIGNUP_FAIL = "USER_SIGNUP_FAIL"

export const USER_LOAD_REQUEST = "USER_LOAD_REQUEST"
export const USER_LOAD_SUCCESS = "USER_LOAD_SUCCESS"
export const USER_LOAD_FAIL = "USER_LOAD_FAIL"

export const USER_LOGOUT_REQUEST = "USER_LOGOUT_REQUEST"
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS"
export const USER_LOGOUT_FAIL = "USER_LOGOUT_FAIL"

export const USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST"
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS"
export const USER_UPDATE_FAIL = "USER_UPDATE_FAIL"

export const USER_UPDATEPASS_REQUEST = "USER_UPDATEPASS_REQUEST"
export const USER_UPDATEPASS_SUCCESS = "USER_UPDATEPASS_SUCCESS"
export const USER_UPDATEPASS_FAIL = "USER_UPDATEPASS_FAIL"

export const USER_DELETE_REQUEST = "USER_DELETE_REQUEST"
export const USER_DELETE_SUCCESS = "USER_DELETE_SUCCESS"
export const USER_DELETE_FAIL = "USER_DELETE_FAIL"

export const USER_FORGOT_REQUEST = "USER_FORGOT_REQUEST"
export const USER_FORGOT_SUCCESS = "USER_FORGOT_SUCCESS"
export const USER_FORGOT_FAIL = "USER_FORGOT_FAIL"

export const FORGOT_RESET_REQUEST = "FORGOT_RESET_REQUEST"
export const FORGOT_RESET_SUCCESS = "FORGOT_RESET_SUCCESS"
export const FORGOT_RESET_FAIL = "FORGOT_RESET_FAIL"


export const ALL_USERS_REQUEST = "ALL_USERS_REQUEST"
export const ALL_USERS_SUCCESS = "ALL_USERS_SUCCESS"
export const ALL_USERS_FAIL = "ALL_USERS_FAIL"